/**
 * 服务
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/service',
  name: '服务',
  component: Layout,
  redirect: '/service/customization',
  children: [
    {
      path: 'customization',
      name: '定制',
      component: () => import('@/views/service/customization/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'service_customization'
      }
    },
    {
      path: 'customization/detail',
      name: '详情',
      component: () => import('@/views/service/customization/Detail.vue'),
      meta: {
        father: {
          name: '定制',
          path: '/service/customization'
        }
      }
    },

    {
      path: 'documentary',
      name: '跟单文件',
      component: () => import('@/views/service/documentary/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'service_documentary'
      }
    },
    {
      path: 'documentary/detail',
      name: '查看文件',
      component: () => import('@/views/service/documentary/components/SeeFile.vue'),
      meta: {
        father: {
          name: '跟单文件',
          path: '/service/documentary'
        }
      }
    },

    {
      path: 'attachment',
      name: '配件绑定',
      component: () => import('@/views/service/attachment/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'service_attachment'
      }
    }
  ],
}